import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany, options } from '@apexdesigner/schema-tools';

export const organizationProperty = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    name: z.string().nullable().optional().describe('Name'),

    type: options([
      { value: 'Text', name: 'Text' },
      { value: 'Number', name: 'Number' },
      { value: 'Select One', name: 'Select One' },
    ])
      .nullable()
      .optional()
      .describe('Type'),

    validValues: z
      .string()
      .nullable()
      .optional()
      .describe('Valid Values - Options for Select One properties'),

    sequence: z
      .number()
      .nullable()
      .optional()
      .hidden()
      .describe('Sequence - Display order'),

    organizationPropertyValues: hasMany('OrganizationPropertyValue'),
  })
  .describe('A configurable attribute that organizations can be described by.')
  .as('OrganizationProperty');

export { organizationProperty as organizationPropertySchema };
